export default "{\n    \"message\": \"You ({{impersonator}}) are impersonating {{impersonated}}\",\n    \"linkCopied\": \"Impersonation Link Copied!\"\n}\n"